import React, { useEffect, useState } from 'react';
import './form.scss';
import './input.scss';

export default function Input(props) {
  const {
    wrapperClassName = '',
    className = '',
    children,
    type = 'text',
    id,
    name,
    label,
    hasError,
    errorMessage,
    labelAfter,
    onChange = () => {},
    onAutoFill,
    onInput: onInputProp,
    ...restProps
  } = props;

  const [ showError, setShowError ] = useState(hasError);

  const radioCheck = type === 'checkbox' || type === 'radio';
  const classes = ['form__input', ...className.split(' ')];
  const wrapperClasses = ['form__item', `form__item--${type}`, ...wrapperClassName.split(' ')];

  if (labelAfter) { wrapperClasses.push('form__item--label-after'); }

  const renderLabel = () => label ? (<label htmlFor={id}>{ label }</label>) : null;

  const syncValue = (e) => {
    setShowError(!e.target.checkValidity());
    onChange(e);
  };

  const onValueChange = (e) => {
    syncValue(e);
  };

  const onAutoFillStart = (e) => {
    if (e.animationName === 'onAutoFillStart') {
      const autoFillEvent = { target: e.target };
      if (onAutoFill) {
        onAutoFill(autoFillEvent);
      } else {
        syncValue(autoFillEvent);
      }
    }
  };

  const onInput = (e) => {
    if (onAutoFill && e.target.matches(':-webkit-autofill, :autofill')) {
      onAutoFill({ target: e.target });
    }
    if (onInputProp) {
      onInputProp(e);
    }
  };

  useEffect(() => {
    if (hasError !== showError) {
      setShowError(hasError);
    }
  }, [hasError]);

  return (
    <div className={`${wrapperClasses.join(' ')}${ showError ? ' form__item--error' : '' }`}>
      { (!radioCheck && !labelAfter) ? renderLabel() : null }
      <input
        className={classes.join(' ')}
        id={id}
        name={name}
        type={type}
        onChange={onValueChange}
        onAnimationStart={onAutoFillStart}
        onInput={onInput}
        {...restProps}
        // eslint-disable-next-line
        pattern={type === 'email' ? '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$' : props.pattern } // remove + sign || default: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        />
      { (radioCheck || labelAfter) ? renderLabel() : null }
      { showError && errorMessage ? (<p className="p--3 fc--negative mt--1 mb--0">{ errorMessage }</p>) : null }
      { children }
    </div>
  )
};
